import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { SkipLink } from '../skip-link/SkipLink';

import styles from './skip-links.scss';

interface Link {
  id?: number;
  name?: string;
  url?: string;
}

interface SkipLinksProps {
  links: Link[];
}

export const SkipLinks = ({ links }: SkipLinksProps) => (
  <LinkList
    links={links}
    Item={SkipLink}
    className={styles.skip}
    children={undefined}
  />
);
